var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"remove icon-otzar icon-circle icon-bg icon-remove",on:{"click":_vm.remove}},[_vm._v("\n    F\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }